import { render, staticRenderFns } from "./livebofang.vue?vue&type=template&id=e81848ea&scoped=true"
import script from "./livebofang.vue?vue&type=script&lang=js"
export * from "./livebofang.vue?vue&type=script&lang=js"
import style0 from "./livebofang.vue?vue&type=style&index=0&id=e81848ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81848ea",
  null
  
)

export default component.exports